import React, { Fragment, useEffect, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { Auth, AuthState, onAuthUIStateChange, getCurrentAuthState } from "../../api";

// Wraps children and injects the current `authState` prop (signedIn / signedOut).
export function Authenticator({ children }) {
  const [state, setState] = useState(getCurrentAuthState().state);
  useEffect(() => onAuthUIStateChange((next) => setState(next)), []);

  const propAuthState = state === AuthState.SignedIn ? "signedIn" : state === AuthState.Loading ? "loading" : "signedOut";
  return (
    <Fragment>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(child, { authState: propAuthState });
      })}
    </Fragment>
  );
}

// Presents a "Sign In" button that redirects to the WorkOS AuthKit hosted UI.
// Sign-up is handled on the same WorkOS screen — no separate form needed.
export function AmplifyAuthenticator({ onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    return onAuthUIStateChange((next) => {
      if (next === AuthState.SignedIn && onClose) onClose();
    });
  }, [onClose]);

  const handleSignIn = async () => {
    setLoading(true);
    setError(null);
    try {
      await Auth.signIn();
      // Auth.signIn() redirects the browser — code below only runs on error.
    } catch (err) {
      setError(err.message || "Could not reach the sign-in service");
      setLoading(false);
    }
  };

  return (
    <div style={{ textAlign: "center", padding: "16px 0" }}>
      {error && <p style={{ color: "red", marginBottom: "12px" }}>{error}</p>}
      <Button
        variant="primary"
        onClick={handleSignIn}
        disabled={loading}
        style={{ minWidth: "160px" }}
      >
        {loading ? <Spinner animation="border" size="sm" /> : "Continue to sign in"}
      </Button>
    </div>
  );
}

// Compatibility shims retained for call-sites that still import these names.
export function AmplifySignUp({ children }) {
  return <Fragment>{children}</Fragment>;
}
export function AmplifySignIn({ children }) {
  return <Fragment>{children}</Fragment>;
}
export function AmplifySignOut({ children }) {
  return <Fragment>{children}</Fragment>;
}
